import { render, staticRenderFns } from "./OrderOnlinePickUp.vue?vue&type=template&id=3ee8481a&"
import script from "./OrderOnlinePickUp.vue?vue&type=script&lang=js&"
export * from "./OrderOnlinePickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports